import { theme } from "@huub-web/ui/theme/css/theme.css";
import { responsive } from "@huub-web/ui/utils/responsive";
import { transition } from "@huub-web/ui/utils/transition";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const photoGridStyle = style({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: theme.spacings.s,
  ...responsive({
    s: {
      gridTemplateColumns: "repeat(6, 1fr)",
    },
  }),
});

export const photoItemStyle = style({
  aspectRatio: "4 /3",
  cursor: "pointer",
  outline: "none",
  selectors: {
    "&:focus-visible": {
      outline: `2px solid ${theme.colors.primary}`,
      outlineOffset: 2,
      borderRadius: theme.borderRadiuses.xxs,
    },
  },
});

export const radioIndicatorStyle = recipe({
  base: {
    position: "absolute",
    top: 8,
    right: 8,
    width: 24,
    height: 24,
    borderRadius: "50%",
    border: "2px solid white",
    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
    pointerEvents: "none",
    transition: transition("background-color"),
  },
  variants: {
    selected: {
      true: {
        backgroundColor: theme.colors.primary,
        borderColor: theme.colors.primary,
        selectors: {
          "&::after": {
            content: "''",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: "white",
          },
        },
      },
      false: {
        backgroundColor: "rgba(255,255,255,0.7)",
      },
    },
  },
  defaultVariants: {
    selected: false,
  },
});

/**
 * Stacked modal title (title + address). Resets the inherited nowrap and adds
 * a little bottom room so the address descenders aren't clipped by the title's
 * overflow:hidden ellipsis treatment.
 */
export const modalTitleStyle = style({
  whiteSpace: "normal",
  paddingBottom: rem(4),
});

export const modalConstraintStyle = style({
  maxHeight: "90dvh",
});

export const scrollableContentStyle = style({
  flex: 1,
  minHeight: 0,
});

export const contentWrapperStyle = style({
  minHeight: 400,
});

export const footerStyle = style({
  display: "flex",
  justifyContent: "flex-end",
});
